import * as yup from 'yup';

const SymptomEditSchema = yup.object({
  status: yup.string().required('Importance level is required'),
  notes: yup.string().required('Notes is required'),
});

export { SymptomEditSchema };
